import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB45XdCfRnuitF7LkaJsbxr5jWpQDDbKjI",
  authDomain: "web-app-838d9.firebaseapp.com",
  projectId: "web-app-838d9",
  storageBucket: "web-app-838d9.appspot.com",
  messagingSenderId: "1026246408036",
  appId: "1:1026246408036:web:6b0d1bfb0e2c8441e12c71"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);